import { render, staticRenderFns } from "./CommissionTypeAccountingConfigurationForm.vue?vue&type=template&id=47a3e2f6"
import script from "./CommissionTypeAccountingConfigurationForm.vue?vue&type=script&lang=js"
export * from "./CommissionTypeAccountingConfigurationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports